import { render, staticRenderFns } from "./UsageLimits.vue?vue&type=template&id=5078a0f3&"
import script from "./UsageLimits.vue?vue&type=script&lang=js&"
export * from "./UsageLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports